<template>
  <div class="public-content cutting-tangent">
    <div class="breadcrumb">合成区类型管理</div>
    <div class="add-category">
      <div class="cutName">
        <span style="maring:0 10px 0 0">关键词:</span>
        <el-input v-model="areaName" clearable placeholder="请输入关键词"></el-input>
      </div>
      <div>
        <el-button round @click="queryInfo.pageNum = 1, onSubmit()">查询</el-button>
        <el-button round type="primary" v-permission="'pms:admin:cut:add'" @click="newBuilt()"> 新建合成区类型 </el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="areatingTangentList" border style="width: 100%">
          <el-table-column prop="areaName" label="合成区类型名称" min-width="180"></el-table-column>
          <el-table-column label="规格" min-width="180">
            <template v-slot="scope"> 上: {{ scope.row.areaTop }}mm 下: {{ scope.row.areaBottom }}mm <br> 左: {{ scope.row.areaLeft }}mm 右: {{ scope.row.areaRight }}mm </template>
          </el-table-column>
          <el-table-column prop="barcodePosition" label="合成区条码位置" min-width="180">
            <template slot-scope="scope">{{ $config.barcodePosition[scope.row.barcodePosition] }}</template>
          </el-table-column>
          <el-table-column label="左侧合成码" min-width="180">
            <template slot-scope="scope"> {{ $config.leftComposeCode[scope.row.leftComposeCode] }} </template>
          </el-table-column>
          <el-table-column label="操作" min-width="180">
            <template v-slot="scope">
              <span class="color-blue" @click="edit(scope.row)" v-permission="'pms:admin:cut:update'">编辑</span><br>
              <span class="color-blue" @click="deleteId = scope.row.id, deleteDialog = true" v-permission="'pms:admin:cut:delete'" style="margin: 0 5px">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该合成区类型？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteMenu(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index'
import { areaListPaging, areaDelete } from '@/api/pms'
export default {
  name: 'cutting-tangent',
  components: {
    VPagination
  },
  data () {
    return {
      deleteId: '',
      deleteDialog: false,
      areatingTangentList: [],
      areaName: '',
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.areaName = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    this.getCutting()
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    newBuilt () {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.areaName))
      this.$router.push('/createcuttingtangent')
    },
    edit (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.areaName))
      this.$router.push({ path: '/createcuttingtangent', query: { id: row.id } })
    },
    onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.areaName))
      }
      this.getCutting()
    },
    getCutting () {
      areaListPaging({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, areaName: { areaName: this.areaName } }).then((res) => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.getCutting(this.queryInfo)
          }
          this.queryInfo.total = res.data.data.total
          this.areatingTangentList = res.data.data.records
        }
      })
    },
    deleteMenu (id) {
      areaDelete(id).then(res => {
        if (res.data.success) {
          this.getCutting()
          this.$message.success('删除成功')
          this.deleteDialog = false
          // this.$router.go(-1)
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getCutting()
    }
  }
}
</script>
<style scoped lang="less">
.cutting-tangent {
  .add-category {
    justify-content: space-between;
  }

  .cutName {
    display: flex;
    justify-content: space-around;
    width: 250px;
    align-items: center;

    .el-input {
      width: 180px;
    }
  }
}
</style>
